/**
 * Centralized feature flag keys used with FeatureFlagService.
 *
 * @example
 * featureFlagService.getFeatureFlag(FEATURE_FLAGS.KICKBACK_CREATE)
 */
export const FEATURE_FLAGS = {
  /** Controls whether the kickback policy creation feature is enabled. */
  CUSTOMER_ENTRANCE: 'emobility.commercial.customer-entrance',
  PRICE_POLICY_V2_CREATE: 'emobility.commercial.dynamicpricing.create',
  PRICE_REGULATIONS_READ: 'emobility.commercial.price-regulations.read',
  POWER_PRICE_EXCLUSION: 'emobility.commercial.power-price-exclusion',
  VALIDATE_NET_AREA_FOR_PRICE_POLICY: 'emobility.commercial.validate-net-area-for-price-policy',
} as const;
